import { client } from '@api/client';
import { URL } from '@api/urls';

import { IItemsResponse } from '@interfaces/common/response';
import { IAssetRentRequest } from '@interfaces/rent/assetRent';
import { IAssetProfileIncomingRequestsDTO } from '@interfaces/rent/dto/assetRequestsDTO';

const {
	assetProfileIncomingRequests,
} = URL;

export const getAssetProfileIncomingRequests = (
	params: IAssetProfileIncomingRequestsDTO,
): Promise<IItemsResponse<IAssetRentRequest>> => {
	return client.get(assetProfileIncomingRequests, {
		params,
	});
};
